import type { BaseItemSchema } from "@memorang/types";
import { getHasResponse } from "../containers/StudySessionBottombarContainer/session-items-nav";
import useSessionStore from "./useSessionStore";

export const useBlockAnsweredState = (block: BaseItemSchema[] = []) => {
	const itemStates = useSessionStore((s) => s.itemStates);
	const answers = useSessionStore((s) => s.answers);

	const numItemsLeft = block.filter(
		(item) => !getHasResponse(item, itemStates, answers),
	).length;

	return {
		isAnswered: numItemsLeft < block.length,
		numItemsLeft,
	};
};
